import { useState } from 'react';
import { Box } from '@mui/material';
import { getCelebrationOrigin, useCelebration } from './celebrate';
import { drawCoin } from './holidayShapes';
import { random, useCanvasAnimation } from './useCanvasAnimation';

const GRAVITY = 0.0018; // px per ms²

/** St. Patrick's: a pot of gold's worth of coins pops out of the bind-in-progress message when a policy binds. */
export const CoinShower = () => {
  const [runKey, setRunKey] = useState(0);
  useCelebration('bind', () => setRunKey((key) => key + 1));

  const canvasRef = useCanvasAnimation({
    enabled: runKey > 0,
    runKey,
    createStep: ({ height }) => {
      const origin = getCelebrationOrigin();
      const coins = Array.from({ length: 40 }, () => {
        const angle = random(-Math.PI * 0.85, -Math.PI * 0.15);
        const speed = random(0.5, 1);
        return {
          x: origin.x + random(-20, 20),
          y: origin.y,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed,
          size: random(7, 11),
          spin: random(0, Math.PI * 2),
          spinSpeed: random(0.008, 0.02),
        };
      });

      return (ctx, dt) => {
        let visible = 0;
        for (const c of coins) {
          c.vy += GRAVITY * dt;
          c.x += c.vx * dt;
          c.y += c.vy * dt;
          c.spin += c.spinSpeed * dt;
          if (c.y > height + 20) continue;
          visible++;
          drawCoin(ctx, c.x, c.y, c.size, c.spin);
        }
        return visible > 0;
      };
    },
  });

  return <Box component='canvas' ref={canvasRef} aria-hidden sx={sxStyles.canvas} />;
};

const sxStyles = {
  canvas: {
    position: 'fixed',
    inset: 0,
    width: '100vw',
    height: '100vh',
    pointerEvents: 'none',
    zIndex: 1250,
  },
};
